import { render, staticRenderFns } from "./Developer.vue?vue&type=template&id=5e36638e&scoped=true&"
import script from "./Developer.vue?vue&type=script&lang=js&"
export * from "./Developer.vue?vue&type=script&lang=js&"
import style0 from "./Developer.vue?vue&type=style&index=0&id=5e36638e&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../env/lib/node_modules/@vue/cli-service/node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "5e36638e",
  null
  
)

export default component.exports